import customaxios from ".";

export const createCart = (data: any) => {
  return customaxios({
    method: "POST",
    url: `/cart/create/`,
    data,
  });
};

export const getCartSummary = () => {
  return customaxios({
    method: "GET",
    url: `/cart/summary/`,
  });
};

export const getCartDetails = () => {
  return customaxios({
    method: "GET",
    url: `/cart/`,
  });
};

export const deletePartnerByServiceId = (serviceId: number) => {
  return customaxios({
    method: "DELETE",
    url: `/cart/`,
    params: {
      serviceId: serviceId,
    },
  });
};

export const deletePartnerByCartItemId = (cartItemId: number) => {
  return customaxios({
    method: "DELETE",
    url: `/cart/`,
    params: {
      cartItemIds: cartItemId,
    },
  });
};

export const getCartCount = () => {
  return customaxios({
    method: "GET",
    url: `/cart/items/count`,
  });
};

export const createPlannerCart = (data: { packageId: number }) => {
  return customaxios({
    method: "POST",
    url: `/cart/planner/create`,
    data,
  });
};

export const getPlannerCartSummary = () => {
  return customaxios({
    method: "GET",
    url: `/cart/planner/summary`,
  });
};

export const getPlannerCount = () => {
  return customaxios({
    method: "GET",
    url: `/cart/planner/items/count`,
  });
};
